export default {
  run(ed) {
    const em = ed.getModel();
    const models = [...ed.getSelectedAll()];
    models.length && em.set('clipboard', models);
  }
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/commands/view/CopyComponent.js